if (!customElements.get('wp-product-form')) {
  customElements.define(
    'wp-product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        // Defer setup to ensure light-DOM children are parsed
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this._init(), { once: true });
        } else {
          // next frame to allow Liquid-rendered content to attach
          requestAnimationFrame(() => this._init());
        }
      }

      _init() {
        this.form = this.querySelector('form');
        if (!this.form) {
          // Retry shortly if not yet available (e.g., deferred render)
          setTimeout(() => this._init(), 50);
          return;
        }
        // Ensure variantIdInput exists before touching
        const vid = this.variantIdInput;
        if (vid) {
          vid.disabled = false;
        }

        // Bind clicks on primary CTA(s)
        this.submitButton = this.querySelectorAll('.buy-button__cta, .add-to-cart__submit-button');
        this.submitButton.forEach((button) => {
          button.addEventListener('click', this.onSubmitHandler.bind(this));
        });
        // Also bind to form submit as a fallback (covers Enter key and unexpected DOM)
        this.form.addEventListener('submit', this.onFormSubmitHandler.bind(this));

        this.additionalProducts = [];

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.allocationPriceRender = this.querySelector('[allocation-price-render]');
        this.checkedAllocation = this.querySelector('.delivery-item [checked]');

        if (this.checkedAllocation && this.checkedAllocation) {
          this.allocationPriceRender && (this.allocationPriceRender.textContent = this.checkedAllocation.dataset.variantPrice);
        }



        // document.querySelectorAll('.delivery-item input[type="radio"][data-radio-type="selling_plan"]').forEach((radio) => {
        //   console.log('radio', radio);
        //   if(radio.parentElement.classList.contains('active')){
        //     console.log('radio 2', radio.getAttribute('qty'));
        //   }
        // });
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        const btn = evt.currentTarget || evt.target;
        if (btn && btn.getAttribute('aria-disabled') === 'true') return;
        btn.setAttribute('aria-busy', 'true');
        this.handleErrorMessage();

        if (btn) {
          btn.setAttribute('aria-disabled', true);
          btn.classList.add('loading');
          
        } 

        const config = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: `application/javascript` },
        };
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        let product = this.form.querySelector('[name=id]').value;
        const subscription_promo_product = this.form.querySelector('[name=subscription_promo_product]');

        const qtyInput = this.form.querySelector('[name="quantity"]');
     
        let quantity = qtyInput && qtyInput.value !== '' ? Number(qtyInput.value) : null;

        const spInput = this.form.querySelector('[name="selling_plan"]');
        let sellingPlanId = spInput && spInput.value !== '' ? spInput.value : null;
      /*  if (quantity === null || Number.isNaN(quantity)) {
          const activePlanQtyEl = document.querySelector('li.delivery-item.active input[type="radio"][data-radio-type="selling_plan"]');
          quantity = activePlanQtyEl ? Number(String(activePlanQtyEl.getAttribute('qty')||'').replace(/\s/g, '')) : 1;
        }*/
        let formData = {
          items: [{ id: product, quantity: Number(quantity), selling_plan: sellingPlanId }]
        };




        fetch(`${routes.cart_add_url}`, {
          ...config,
          body: JSON.stringify(formData)
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage = (btn && btn.querySelector) ? btn.querySelector('.sold-out-message') : null;
              if (!soldOutMessage) return;
              if (btn) btn.setAttribute('aria-disabled', true);
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }
            if (!this.error)
              this.error = false;
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (btn) btn.classList.remove('loading');
            theme.Header.openCartDrawer();
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error && btn) btn.removeAttribute('aria-disabled');
            btn.removeAttribute('aria-busy');
            btn.classList.remove('is-loading');
            /*
            window.SLIDECART_UPDATE(window.SLIDECART_OPEN());
            //se coloca el set timeout para darle tiempo q renderize el draw cart
            setTimeout(function(){
              if(subscription_promo_product && subscription_promo_product.value){
                let buttons = document.querySelectorAll(`.item[data-line-item-id="${subscription_promo_product.value}"] .quantity-selector button`);
                let inputs = document.querySelectorAll(`.item[data-line-item-id="${subscription_promo_product.value}"] .quantity-selector input`);
                if(buttons.length > 0) {
                  buttons.forEach((button) => {
                    button.style.display = 'none';
                  });
                }

                if(inputs.length > 0) {
                  inputs.forEach((input) => {
                    input.setAttribute('disabled', 'disabled');
                    input.setAttribute('style', 'pointer-events: none;');
                    input.setAttribute('style', 'border: none !important;');
                  });
                }
              }
            }, 500);
            */
          });
      }

      // Fallback for form submit (Enter key or if click listener didn't attach)
      onFormSubmitHandler(evt){
        evt.preventDefault();
        theme.Header.openCartDrawer();
        const submitter = evt.submitter || this.querySelector('.buy-button__cta, .add-to-cart__submit-button');
        // Reuse main handler with the submitter as currentTarget
        const synthetic = { ...evt, currentTarget: submitter, target: submitter, preventDefault: ()=>{} };
        return this.onSubmitHandler(synthetic);
      }

    

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return; 

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
